/* MYM AI assistant widget: one chat for styling and customer care (intent detected per message by the backend), search by photo, WhatsApp handoff. EN/AR.
   The conversation is kept on this device (localStorage, 30 days, last 50 messages) per browser visitor id and signed-in customer, and survives
   page changes, reloads and EN/AR switches; the open/closed state lives in sessionStorage. Taste signals (searched words, viewed, clicked, added
   to bag) are sent with each message so the backend can rank suggestions and complete the look. "Forget me" clears both.
   23 Oct (round 3): every result set of 2+ pieces has "View all" (storefront page with all proposed pieces, same order); on a new
   visit the backend may send a useful welcome back; typing "forget me" in the chat clears this device too. */
(function () {
  'use strict';
  var root = document.getElementById('mym-ai-root');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var API = (root.dataset.api || '').replace(/\/+$/, '');
  var WA = root.dataset.wa || '966560011412';
  var embedded = root.dataset.embedded === 'true';
  var lang = root.dataset.locale === 'ar' ? 'ar' : 'en';
  var ctx = null;
  try { var c = document.getElementById('mym-ai-customer'); if (c) ctx = JSON.parse(c.textContent); } catch (e) { ctx = null; }
  var customer = root.dataset.cid && root.dataset.csig ? { id: String(root.dataset.cid), day: root.dataset.cday, sig: root.dataset.csig } : null;
  if (!customer) ctx = null;
  if (ctx && /^(test|testing|demo|guest|customer|undefined|null)$/i.test(String(ctx.first_name || '').trim())) ctx.first_name = '';
  var here = root.dataset.productId ? { id: Number(root.dataset.productId), handle: root.dataset.productHandle || '', title: root.dataset.productTitle || '' } : null;
  if (!here) { // fallback: Shopify's page meta and the URL
    var pm = /\/products\/([^\/?#]+)/.exec(location.pathname), meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
    if (pm) here = { id: meta && Number(meta.id) || null, handle: decodeURIComponent(pm[1]), title: '' };
  }

  var DAY = 864e5, KEEP = 30 * DAY, MAX_MSGS = 50, MAX_EVENTS = 100;

  var T = {
    en: {
      launcher: 'Chat with us', title: 'MIRA Y MANO', close: 'Close', newChat: 'New chat',
      hi: 'Welcome to MIRA Y MANO. Ask for a styling idea, share a photo of a look, or ask about delivery and exchanges.',
      hiName: 'Welcome back, {n}. ',
      chips: ['What suits my style?', 'Delivery times', 'Exchanges', 'Talk to the team'],
      picked: 'Here’s the {x} you picked. Want to see what goes with it?', crossQ: 'What goes with it?',
      placeholder: 'Ask us anything…', placeholderPaste: 'Ask or paste a photo…', send: 'Send', photo: 'Search by photo',
      photoExact: 'Exact match', photoTitle: 'Closest pieces in stock', photoLow: 'No close match. Here are similar styles in stock.', photoNone: 'No in-stock pieces matched this photo.',
      thinking: 'One moment…', still: 'Still looking…', wa: 'Continue on WhatsApp', waFooter: 'WhatsApp our team', opening: 'Opening WhatsApp…',
      notSent: 'Not sent', retry: 'Retry', privacyBtn: 'Privacy', clearQ: 'Clear your preferences and this conversation from this device?', newQ: 'Start a new conversation? This one will be cleared.', clear: 'Clear', start: 'Start new', cancel: 'Cancel', photoShared: 'Photo shared',
      err: { offline: 'You’re offline. Check your connection, then tap Retry.', rate_limited: 'Too many requests. Please try again in a minute.', image_too_large: 'This photo is too large. Please choose a smaller one.', unsupported_media: 'This photo could not be read. Please use a JPEG, PNG or WebP image.', generic: 'Something went wrong. Please try again, or continue on WhatsApp.' },
      memory: 'We remember your preferences on this device to suggest better pieces.', forget: 'Forget me', forgotten: 'Done. Your preferences and this conversation are cleared from this device.',
      viewAll: 'View all', removePhoto: 'Remove photo', previewPhoto: 'Photo ready to send', privacy: 'Your photos are used to find similar pieces and are not stored.', yourPhoto: 'Your photo', from: 'SR'
    },
    ar: {
      launcher: 'تحدثي معنا', title: 'MIRA Y MANO', close: 'إغلاق', newChat: 'محادثة جديدة',
      hi: 'أهلًا بكِ في MIRA Y MANO. اطلبي فكرة تنسيق، أو أرسلي صورة لإطلالة، أو اسألي عن التوصيل والاستبدال.',
      hiName: 'أهلاً بعودتك يا {n}. ',
      chips: ['ما الذي يناسب أسلوبي؟', 'مدة التوصيل', 'الاستبدال', 'التحدث مع الفريق'],
      picked: 'هذه القطعة التي اخترتِها: {x}. هل تودّين رؤية ما يناسبها؟', crossQ: 'ماذا يناسبها؟',
      placeholder: 'اسألينا عن أي شيء…', placeholderPaste: 'اسألي أو الصقي صورة…', send: 'إرسال', photo: 'البحث بالصورة',
      photoExact: 'القطعة نفسها', photoTitle: 'أقرب القطع المتوفرة', photoLow: 'لا يوجد تطابق قريب. إليكِ تصاميم مشابهة متوفرة.', photoNone: 'لم نجد قطعًا متوفرة مطابقة لهذه الصورة.',
      thinking: 'لحظة من فضلك…', still: 'ما زلت أبحث…', wa: 'المتابعة عبر واتساب', waFooter: 'تواصلي مع فريقنا عبر واتساب', opening: 'جارٍ فتح واتساب…',
      notSent: 'لم تُرسل', retry: 'إعادة المحاولة', privacyBtn: 'الخصوصية', clearQ: 'مسح تفضيلاتك وهذه المحادثة من هذا الجهاز؟', newQ: 'بدء محادثة جديدة؟ ستُمسح هذه المحادثة.', clear: 'مسح', start: 'بدء محادثة', cancel: 'إلغاء', photoShared: 'صورة مُرسلة',
      err: { offline: 'لا يوجد اتصال بالإنترنت. تحقّقي من الاتصال ثم اضغطي «إعادة المحاولة».', rate_limited: 'تعذّر إكمال الطلب الآن. يُرجى المحاولة بعد دقيقة.', image_too_large: 'الصورة كبيرة جدًا. يُرجى اختيار صورة أصغر.', unsupported_media: 'تعذّرت قراءة الصورة. يُرجى استخدام صورة JPEG أو PNG أو WebP.', generic: 'حدث خطأ ما. يُرجى المحاولة مرة أخرى أو المتابعة عبر واتساب.' },
      memory: 'نتذكّر تفضيلاتك على هذا الجهاز لنقترح عليكِ قطعًا أنسب.', forget: 'مسح تفضيلاتي', forgotten: 'تم. مُسحت تفضيلاتك وهذه المحادثة من هذا الجهاز.',
      viewAll: 'عرض الكل', removePhoto: 'إزالة الصورة', previewPhoto: 'الصورة جاهزة للإرسال', privacy: 'نستخدم صورتك للعثور على قطع مشابهة ولا نحتفظ بها.', yourPhoto: 'صورتك', from: 'ر.س'
    }
  };
  var t = T[lang];

  /* ---------- device memory ---------- */
  function store(kind) { try { var s = window[kind]; var k = '__mym_ai_t'; s.setItem(k, '1'); s.removeItem(k); return s; } catch (e) { return null; } }
  var LS = store('localStorage'), SS = store('sessionStorage');
  function rd(s, k) { try { return s ? JSON.parse(s.getItem(k)) : null; } catch (e) { return null; } }
  function wr(s, k, v) { try { if (s) s.setItem(k, JSON.stringify(v)); } catch (e) { /* storage full: keep going in memory */ } }
  function rm(s, k) { try { if (s) s.removeItem(k); } catch (e) {} }
  function uuid() { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); var a = new Uint8Array(16); (window.crypto || {}).getRandomValues ? crypto.getRandomValues(a) : a.forEach(function (_, i) { a[i] = Math.random() * 256; }); return Array.prototype.map.call(a, function (b) { return ('0' + b.toString(16)).slice(-2); }).join(''); }

  // Visitor id: read on every use, so "Forget me" in one tab applies to all tabs. Without localStorage nothing is sent.
  var memVid = null;
  function getVid() {
    var v = rd(LS, 'mym_ai_vid');
    if (typeof v === 'string' && /^[a-z0-9-]{16,64}$/i.test(v)) return v;
    if (!LS) return memVid || (memVid = uuid());
    v = uuid(); wr(LS, 'mym_ai_vid', v); return v;
  }
  var who = function () { return customer ? 'c' + customer.id : 'anon'; };
  var tkey = function () { return 'mym_ai_thread:' + getVid() + ':' + who(); };
  var ekey = function () { return 'mym_ai_events:' + getVid() + ':' + who(); }; // a shared device keeps each customer's signals apart

  function fresh() { return { v: 1, thread: [], session: null, anchor: null, updated: Date.now() }; }
  function loadThread() {
    var d = rd(LS, tkey());
    if (!d && customer && LS) { // first sign-in on this device keeps the chat, unless another customer already used this browser
      var vid = getVid(), other = Object.keys(LS).some(function (k) { return k.indexOf('mym_ai_thread:' + vid + ':c') === 0; });
      var anon = !other && rd(LS, 'mym_ai_thread:' + vid + ':anon');
      if (anon) { d = anon; rm(LS, 'mym_ai_thread:' + vid + ':anon'); var ae = rd(LS, 'mym_ai_events:' + vid + ':anon'); if (ae) { wr(LS, ekey(), ae); rm(LS, 'mym_ai_events:' + vid + ':anon'); } }
    }
    if (!d || !Array.isArray(d.thread) || Date.now() - (d.updated || 0) > KEEP) return fresh();
    d.thread = d.thread.filter(function (m) { return m && (!m.ts || Date.now() - m.ts < KEEP); }).slice(-MAX_MSGS);
    return d;
  }
  var state = loadThread();
  state.thread.forEach(function (m) { if (m.products && m.products.length) m.unverified = true; });
  state.open = false; state.busy = false; state.busySince = 0; state.epoch = 0;
  function save() {
    var keep = state.thread.slice(-MAX_MSGS).map(function (m) { var o = {}; for (var k in m) if (k !== 'image') o[k] = m[k]; if (m.image) o.photo = true; return o; }); // photos are never stored
    wr(LS, tkey(), { v: 1, thread: keep, session: state.session, anchor: state.anchor, updated: Date.now() });
  }

  function events() { var e = rd(LS, ekey()); return Array.isArray(e) ? e.filter(function (x) { return x && Date.now() - x.ts < KEEP; }) : []; }
  function track(k, o) {
    var list = events(), now = Date.now();
    var ev = { k: k, ts: now }; if (o && o.id) ev.id = Number(o.id); if (o && o.w) ev.w = String(o.w).slice(0, 300);
    if (list.some(function (x) { return x.k === ev.k && x.id === ev.id && x.w === ev.w && now - x.ts < 6e4; })) return;
    list.push(ev); wr(LS, ekey(), list.slice(-MAX_EVENTS));
  }
  // Signals for the taste profile: this product page, and add-to-bag on it.
  if (here && here.id) track('v', { id: here.id });
  document.addEventListener('submit', function (e) {
    var f = e.target; if (!f || !f.getAttribute) return;
    if (!/\/cart\/add/.test(f.getAttribute('action') || '') || !here || !here.id) return;
    var pidIn = f.querySelector('[name="product-id"]'); // quick-add forms for other pieces carry their own product id
    if (pidIn && Number(pidIn.value) !== here.id) return;
    track('a', { id: here.id });
  }, true);

  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  // Customer-facing product name (mirrors backend lib/titles.mjs): style codes and model/collection names before a dash are dropped.
  var CAT = /\b(abayas?|dress(es)?|kaftans?|kimonos?|coats?|jackets?|scarf|scarves|shawls?|bags?|clutch|pouch|perfumes?|shoes|flats|mules|sandals|heels|rings?|necklaces?|bracelets?|earrings?|anklets?|sets?|jalabiyas?|tops?|skirts?|trousers|pants|belts?|hats?|turbans?|wallets?)\b/i;
  var COLW = /^(black|white|ivory|cream|off[- ]?white|beige|nude|camel|brown|navy|blue|green|olive|grey|gray|silver|gold|pink|red|maroon|burgundy|purple|lilac|orange|yellow|dark|light)\b/i;
  var DESC = /^(dusty|printed|signature|classic|embroidered|pleated|plain|washed|linen|silk|satin|cotton|velvet|chiffon|crepe|leather|suede|wool|sheer|long|short|oversized|layered|belted|beaded)$/i;
  function cleanTitle(x) {
    x = String(x || '').trim(); var m = /^(.{1,40}?)\s+[–-]\s+(.+)$/.exec(x);
    if (m) { var r = m[2].trim(), c = CAT.exec(m[1]); if (c && !CAT.test(r) && !/[؀-ۿ]/.test(r)) r += ' ' + c[0].charAt(0).toUpperCase() + c[0].slice(1); return r; }
    var k = /^[A-Z]*\d[A-Z0-9-]*\s+([A-Z][A-Z ]{2,})$/.exec(x); // "DW26-014 ABAYA" -> "Abaya"
    if (k && k[1].trim() !== 'MYM') return k[1].trim().toLowerCase().replace(/\s+/g, ' ').replace(/^./, function (q) { return q.toUpperCase(); });
    var ka = /^[A-Z]*\d[A-Z0-9-]*\s+([\u0600-\u06FF].*)$/.exec(x); // "DW26-014 عباية" -> "عباية"
    if (ka) return ka[1].trim();
    var l = /^([A-Z][a-z]{2,})\s+(.+)$/.exec(x); // a model name in front of the colour
    return l && !COLW.test(l[1]) && !DESC.test(l[1]) && COLW.test(l[2]) && CAT.test(l[2]) ? l[2] : x;
  }
  window.MymAiTitle = cleanTitle; // the chat's "View all" page names pieces the same way (round 3)
  var ISO = function (x) { return '\u2068' + x + '\u2069'; };
  var isAr = function (x) { return /[\u0600-\u06FF]/.test(x || ''); };
  function svg(path, size) { var s = '<svg viewBox="0 0 24 24" width="' + (size || 18) + '" height="' + (size || 18) + '" aria-hidden="true" focusable="false">' + path + '</svg>'; var w = document.createElement('span'); w.className = 'mym-ai__ico'; w.innerHTML = s; return w; }
  var ICON = {
    camera: '<path fill="none" stroke="currentColor" stroke-width="1.6" d="M4 8h3l2-3h6l2 3h3v11H4z"/><circle cx="12" cy="13" r="3.5" fill="none" stroke="currentColor" stroke-width="1.6"/>',
    send: '<path fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M13 6l6 6-6 6"/>',
    close: '<path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" d="M6 6l12 12M18 6L6 18"/>',
    compose: '<path fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" d="M12 5H6a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-6M16.5 4.5l3 3L12 15H9v-3z"/>',
    wa: '<path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm5.3 14.2c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-3.3-.8-2.8-1.1-4.5-4-4.7-4.2-.1-.2-1.1-1.5-1.1-2.9s.7-2 1-2.3c.2-.3.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.4 0 .5l-.4.6-.4.4c-.1.2-.3.3-.1.6.2.3.8 1.3 1.7 2.1 1.2 1 2.1 1.3 2.4 1.5.3.1.5.1.6-.1l.9-1.1c.2-.3.4-.2.6-.1l1.9.9c.3.1.5.2.5.3.1.2.1.7-.1 1.2z"/>',
    spark: '<path fill="currentColor" d="M12 2l1.8 6.2L20 10l-6.2 1.8L12 18l-1.8-6.2L4 10l6.2-1.8z"/>'
  };

  /* ---------- layout ---------- */
  var launcher = null;
  if (!embedded) {
    launcher = el('button', 'mym-ai-launcher');
    launcher.type = 'button';
    launcher.setAttribute('aria-haspopup', 'dialog');
    launcher.setAttribute('aria-controls', 'mym-ai-panel');
    launcher.appendChild(svg(ICON.spark, 16));
    launcher.appendChild(el('span', null, t.launcher));
    launcher.addEventListener('click', function () { launcher.classList.remove('has-new'); toggle(true); });
    document.body.appendChild(launcher);
    // Phone product pages: a 48 px icon in the corner until the customer scrolls past the title, then the labelled launcher.
    if (document.body.classList.contains('template-product')) {
      var mqp = window.matchMedia('(max-width: 640px)');
      // While compact it sits on the price row (inline end, vertically centred), so it never covers the title, price or payment line.
      var compact = function () {
        var h = document.querySelector('.product__title'), pr = document.querySelector('.price.price--large') || document.querySelector('.product__info .price');
        var past = h ? h.getBoundingClientRect().bottom < 0 : window.scrollY > window.innerHeight;
        var on = mqp.matches && !past && !state.open;
        launcher.classList.toggle('is-compact', on);
        if (on && pr) { // centred on the price row, and at least 8 px below the title (review r4 R4-03)
          var r = pr.getBoundingClientRect(), y = r.top + window.scrollY + r.height / 2 - 24;
          if (h) y = Math.max(y, h.getBoundingClientRect().bottom + window.scrollY + 8);
          launcher.style.top = Math.round(y) + 'px'; launcher.classList.add('is-on-price');
        }
        else { launcher.style.top = ''; launcher.classList.remove('is-on-price'); }
      };
      launcher.setAttribute('aria-label', t.launcher);
      window.addEventListener('scroll', compact, { passive: true }); window.addEventListener('resize', compact); compact();
    }
    // Mobile homepage: keep the hero buttons clear; show the launcher once the hero is scrolled past.
    if (document.body.classList.contains('template-index')) {
      var mq = window.matchMedia('(max-width: 640px)');
      var gate = function () { launcher.classList.toggle('is-waiting', mq.matches && window.scrollY < window.innerHeight * 0.6 && !state.open); };
      window.addEventListener('scroll', gate, { passive: true }); window.addEventListener('resize', gate); gate();
    }
  }

  var panel = el('section', 'mym-ai-panel');
  panel.id = 'mym-ai-panel';
  panel.setAttribute('data-lenis-prevent', '');
  panel.setAttribute('role', embedded ? 'region' : 'dialog');
  panel.setAttribute('aria-label', t.title);
  panel.dir = lang === 'ar' ? 'rtl' : 'ltr';
  panel.lang = lang;

  // Header: official white wordmark on the ink band (design system: wordmark only, white on dark, the same file as the site header).
  var head = el('header', 'mym-ai-panel__head');
  var nb = el('button', 'mym-ai-panel__new'); nb.type = 'button'; nb.setAttribute('aria-label', t.newChat); nb.title = t.newChat;
  nb.appendChild(svg(ICON.compose, 18)); nb.appendChild(el('span', 'mym-ai-panel__new-label', t.newChat));
  nb.addEventListener('click', function () { if (state.thread.some(function (m) { return m.who === 'me'; })) confirmBar(t.newQ, t.start, newChat); else newChat(); });
  var brand = el('div', 'mym-ai-panel__brand');
  var word = el('img', 'mym-ai-panel__title'); word.src = root.dataset.wordmark; word.alt = t.title; word.width = 1670; word.height = 176; word.dir = 'ltr';
  brand.appendChild(word);
  head.appendChild(nb); head.appendChild(brand);
  if (!embedded) {
    var x = el('button', 'mym-ai-panel__close'); x.type = 'button'; x.setAttribute('aria-label', t.close); x.appendChild(svg(ICON.close, 18));
    x.addEventListener('click', function () { toggle(false); });
    head.appendChild(x);
  } else head.appendChild(el('span', 'mym-ai-panel__spacer'));

  var msgs = el('div', 'mym-ai-msgs'); msgs.setAttribute('aria-live', 'polite');
  var chips = el('div', 'mym-ai-chips');

  var form = el('form', 'mym-ai-input');
  var file = el('input'); file.type = 'file'; file.accept = 'image/jpeg,image/png,image/webp,image/*'; file.hidden = true;
  var cam = el('button', 'mym-ai-input__cam'); cam.type = 'button'; cam.setAttribute('aria-label', t.photo); cam.title = t.photo; cam.appendChild(svg(ICON.camera, 20));
  cam.addEventListener('click', function () { file.click(); });
  file.addEventListener('change', function () { if (file.files && file.files[0]) stagePhoto(file.files[0]); file.value = ''; });
  var input = el('input', 'mym-ai-input__text'); input.type = 'text'; input.maxLength = 2000; input.setAttribute('aria-label', t.placeholder); input.placeholder = window.matchMedia('(pointer: fine)').matches ? t.placeholderPaste : t.placeholder; input.autocomplete = 'off'; // desktop: say a photo can be pasted
  input.addEventListener('focus', function () { if (panel.classList.contains('is-sheet')) setSheet(false); });
  var sendBtn = el('button', 'mym-ai-input__send'); sendBtn.type = 'submit'; sendBtn.setAttribute('aria-label', t.send); sendBtn.appendChild(svg(ICON.send, 18));
  var pendingPhoto = null, photoEpoch = 0;
  var preview = el('div', 'mym-ai-photo-preview'); preview.hidden = true;
  var previewImg = el('img'); previewImg.alt = t.previewPhoto;
  var removePhoto = el('button', 'mym-ai-photo-remove'); removePhoto.type = 'button'; removePhoto.setAttribute('aria-label', t.removePhoto); removePhoto.appendChild(svg(ICON.close, 18));
  preview.appendChild(previewImg); preview.appendChild(el('span', null, t.previewPhoto)); preview.appendChild(removePhoto);
  removePhoto.addEventListener('click', clearPhoto);
  var composer = el('div', 'mym-ai-composer'); composer.appendChild(preview); composer.appendChild(form);
  form.appendChild(file); form.appendChild(cam); form.appendChild(input); form.appendChild(sendBtn);
  function clearPhoto() { photoEpoch++; pendingPhoto = null; preview.hidden = true; previewImg.removeAttribute('src'); }
  function stagePhoto(f) {
    if (state.busy) return;
    var pe = ++photoEpoch;
    shrink(f).then(function (data) { if (pe !== photoEpoch) return; pendingPhoto = data; previewImg.src = data; preview.hidden = false; if (!phone()) input.focus(); }) // Enter sends it
      .catch(function (e) { if (pe === photoEpoch) push({ who: 'bot', kind: 'err', code: e.code, local: true }); });
  }
  function imageFromTransfer(dt) {
    if (!dt) return null;
    var files = Array.prototype.slice.call(dt.files || []);
    if (files.length) return files.find(function (f) { return /^image\//.test(f.type); });
    var item = Array.prototype.slice.call(dt.items || []).find(function (i) { return i.kind === 'file' && /^image\//.test(i.type); });
    return item && item.getAsFile();
  }
  panel.addEventListener('paste', function (e) { if (e.clipboardData && Array.prototype.indexOf.call(e.clipboardData.types, 'text/plain') >= 0) return; var f = imageFromTransfer(e.clipboardData); if (f) { e.preventDefault(); stagePhoto(f); } });
  panel.addEventListener('dragover', function (e) { if (e.dataTransfer && Array.prototype.indexOf.call(e.dataTransfer.types, 'Files') >= 0) { e.preventDefault(); composer.classList.add('is-dragover'); } });
  panel.addEventListener('dragleave', function (e) { if (!panel.contains(e.relatedTarget)) composer.classList.remove('is-dragover'); });
  panel.addEventListener('drop', function (e) { e.preventDefault(); composer.classList.remove('is-dragover'); var f = imageFromTransfer(e.dataTransfer); if (f) stagePhoto(f); });
  form.addEventListener('submit', function (e) { e.preventDefault(); if (state.busy) return; var v = input.value.trim(); if (pendingPhoto) { var data = pendingPhoto; clearPhoto(); input.value = ''; photoSearch(data, v); } else if (v) { input.value = ''; ask(v); } });

  // Footer: one compact row (WhatsApp, Privacy); the privacy notes and "Forget me" open above it.
  var foot = el('footer', 'mym-ai-panel__foot');
  var notes = el('div', 'mym-ai-notes'); notes.hidden = true; notes.id = 'mym-ai-notes';
  var mem = el('p', 'mym-ai-privacy mym-ai-memory');
  mem.appendChild(document.createTextNode(t.memory + ' '));
  var fg = el('button', 'mym-ai-forget', t.forget); fg.type = 'button';
  fg.addEventListener('click', function () { confirmBar(t.clearQ, t.clear, forgetMe); });
  mem.appendChild(fg);
  notes.appendChild(mem); notes.appendChild(el('p', 'mym-ai-privacy', t.privacy));
  var row = el('div', 'mym-ai-foot-row');
  var waLink = el('a', 'mym-ai-foot-wa'); waLink.href = 'https://wa.me/' + WA; waLink.target = '_blank'; waLink.rel = 'noopener';
  waLink.appendChild(svg(ICON.wa, 14)); waLink.appendChild(el('span', null, t.waFooter));
  waLink.addEventListener('click', function (e) { e.preventDefault(); handoff(state.session, waLink); });
  var pv = el('button', 'mym-ai-foot-privacy', t.privacyBtn); pv.type = 'button'; pv.setAttribute('aria-expanded', 'false'); pv.setAttribute('aria-controls', notes.id);
  pv.addEventListener('click', function () { notes.hidden = !notes.hidden; pv.setAttribute('aria-expanded', String(!notes.hidden)); if (!notes.hidden) msgs.scrollTop = msgs.scrollHeight; });
  row.appendChild(waLink); row.appendChild(pv);
  foot.appendChild(notes); foot.appendChild(row);

  // Inline confirmation in the panel (no browser dialogs).
  var confirmEl = null;
  function confirmBar(q, yes, fn) {
    closeConfirm();
    confirmEl = el('div', 'mym-ai-confirm'); confirmEl.setAttribute('role', 'alertdialog'); confirmEl.setAttribute('aria-label', q);
    confirmEl.appendChild(el('p', null, q));
    var y = el('button', 'mym-ai-confirm__yes', yes); y.type = 'button';
    var n = el('button', 'mym-ai-confirm__no', t.cancel); n.type = 'button';
    y.addEventListener('click', function () { closeConfirm(); fn(); });
    n.addEventListener('click', closeConfirm);
    var b = el('div', 'mym-ai-confirm__btns'); b.appendChild(y); b.appendChild(n); confirmEl.appendChild(b);
    panel.insertBefore(confirmEl, composer); y.focus({ preventScroll: true });
  }
  function closeConfirm() { if (confirmEl) { confirmEl.remove(); confirmEl = null; } }

  panel.appendChild(head); panel.appendChild(msgs); panel.appendChild(composer); panel.appendChild(foot);
  root.appendChild(panel);
  root.hidden = false;
  if (embedded) { panel.classList.add('is-open'); state.open = true; }

  /* ---------- behaviour ---------- */
  var phone = function () { return window.matchMedia('(max-width: 640px)').matches; };
  var lockedY = null;
  function setSheet(on) {
    panel.classList.toggle('is-sheet', !!on);
    var lock = state.open && phone() && !embedded;
    document.documentElement.classList.toggle('mym-ai-locked', lock);
    if (lock && lockedY === null) { lockedY = window.scrollY; document.body.style.top = '-' + lockedY + 'px'; }
    if (!lock && lockedY !== null) { var y = lockedY; lockedY = null; document.body.style.top = ''; window.scrollTo(0, y); }
    panel.setAttribute('aria-modal', String(lock));
  }
  window.addEventListener('resize', function () { setSheet(panel.classList.contains('is-sheet')); });
  // opts.restore: reopened after a page change (no focus grab; on phones a lower sheet so the page stays visible).
  function toggle(open, opts) {
    opts = opts || {};
    state.open = open;
    panel.classList.toggle('is-open', open);
    if (launcher) { launcher.setAttribute('aria-expanded', String(open)); launcher.hidden = open; }
    if (!embedded) { if (open) wr(SS, 'mym_ai_open', 1); else rm(SS, 'mym_ai_open'); }
    setSheet(false); // phones: always full screen
    if (!open) closeConfirm();
    if (open) {
      if (!state.thread.length) greet();
      render(true); refreshCards(); welcomeBack();
      if (!opts.restore) setTimeout(function () { input.focus({ preventScroll: true }); }, 50);
    } else if (launcher && !opts.silent) launcher.focus({ preventScroll: true });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && state.open && !embedded) toggle(false); });

  function greet() { push({ who: 'bot', kind: 'hi', greeting: true }); }

  // New visit (empty chat, or 30+ minutes since the last message): ask the backend for a welcome back. It answers only for
  // someone it remembers, once per visit; otherwise the approved welcome above stays as it is.
  var welcomeAsked = false;
  function welcomeBack() {
    if (welcomeAsked || !LS || state.busy) return; welcomeAsked = true;
    var lastTs = 0; state.thread.forEach(function (m) { if (!m.greeting && m.ts > lastTs) lastTs = m.ts; });
    var onlyHi = state.thread.length === 1 && state.thread[0].kind === 'hi';
    if (!onlyHi && Date.now() - lastTs < 30 * 6e4) return;
    var body = { visitor_id: getVid(), locale: lang, events: events() };
    if (ctx) body.context = ctx;
    if (customer) body.customer = customer;
    var ep = state.epoch;
    api('/v1/welcome', body).then(function (j) {
      if (ep !== state.epoch || !j || !j.reply || state.busy) return;
      return live(j.products).then(function (ps) {
        if (ep !== state.epoch || state.busy) return;
        var w = { who: 'bot', kind: 'welcome', greeting: true, text: j.reply, products: ps, viewAll: j.view_all || null, ts: Date.now() };
        var still = state.thread.length === 1 && state.thread[0].kind === 'hi';
        if (still) { state.thread[0] = w; if (j.session_id) state.session = j.session_id; } else state.thread.push(w);
        save(); render(true);
      });
    }).catch(function () {});
  }
  function push(item) { item.ts = item.ts || Date.now(); state.thread.push(item); state.thread = state.thread.slice(-MAX_MSGS); save(); render(); }

  function newChat() {
    state.epoch++; state.busy = false;
    state.thread = []; state.session = null; state.anchor = null; clearPhoto();
    greet(); render(true); input.focus({ preventScroll: true });
  }

  // Clears this device: conversation, signals, picked piece; a new visitor id (also after "forget me" typed in the chat).
  function clearDevice(old) {
    old = old || getVid();
    if (LS) Object.keys(LS).forEach(function (k) { if (k.indexOf('mym_ai_thread:' + old) === 0 || k.indexOf('mym_ai_events:' + old) === 0) rm(LS, k); });
    rm(SS, 'mym_ai_picked'); memVid = null; wr(LS, 'mym_ai_vid', uuid());
    state.thread = []; state.session = null; state.anchor = null; notes.hidden = true; pv.setAttribute('aria-expanded', 'false');
  }

  function forgetMe() {
    if (fg.disabled) return;
    state.epoch++; state.busy = false; clearPhoto();
    var old = getVid(), body = { visitor_id: old }; if (customer) body.customer = customer;
    fg.disabled = true;
    api('/v1/forget', body).then(function () {
      clearDevice(old);
      push({ who: 'bot', kind: 'forgotten', local: true }); render(true);
    }).catch(function () { push({ who: 'bot', kind: 'err', local: true }); })
      .then(function () { fg.disabled = false; });
  }

  // Brand rule (Jo, 22 Oct): the brand is always written MIRA Y MANO in full capitals, in English and Arabic.
  function brandCaps(x) { return String(x).replace(/\bmira\s+y\s+mano\b/gi, 'MIRA Y MANO').replace(/ميرا\s*(?:واي|واى|إي|اي|ي)?\s*مانو/g, 'MIRA Y MANO'); }
  function textOf(m) {
    if (m.kind === 'welcome') return brandCaps(m.text || '');
    if (m.kind === 'hi') return (ctx && ctx.first_name ? t.hiName.replace('{n}', ctx.first_name) : '') + t.hi;
    if (m.kind === 'picked') return t.picked.replace('{x}', ISO(cleanTitle(m.title)));
    if (m.kind === 'forgotten') return t.forgotten;
    if (m.kind === 'err') return T[m.lang || lang].err[m.code] || T[m.lang || lang].err.generic;
    if (m.kind === 'photo') return m.n ? (m.exact ? t.photoExact : t.photoTitle) : t.photoNone; // approved copy (Claude Design 23 Oct): "Closest pieces in stock" when there is no exact match
    return m.who === 'bot' && m.text ? brandCaps(m.text) : m.text;
  }

  function render(forceBottom) {
    var oldTop = msgs.scrollTop, atBottom = forceBottom || msgs.scrollHeight - msgs.clientHeight - oldTop < 80;
    var rowScroll = Array.prototype.map.call(msgs.querySelectorAll('.mym-ai-cards'), function (r) { return r.scrollLeft; });
    msgs.innerHTML = '';
    state.thread.forEach(function (m) { msgs.appendChild(bubble(m)); });
    if (state.busy) {
      var b = el('div', 'mym-ai-msg mym-ai-msg--bot mym-ai-msg--typing'); b.setAttribute('role', 'status');
      var d = el('p', 'mym-ai-dots'); d.setAttribute('aria-label', t.thinking); d.appendChild(el('i')); d.appendChild(el('i')); d.appendChild(el('i')); b.appendChild(d);
      if (Date.now() - state.busySince > 8000) b.appendChild(el('p', 'mym-ai-still', t.still));
      msgs.appendChild(b);
    }
    chips.innerHTML = '';
    var onlyGreeting = state.thread.length === 1 && (state.thread[0].kind === 'hi' || state.thread[0].kind === 'welcome' || state.thread[0].kind === 'forgotten');
    chips.hidden = !onlyGreeting;
    if (onlyGreeting) t.chips.forEach(function (c, i) {
      var b = el('button', 'mym-ai-chip', c); b.type = 'button';
      b.addEventListener('click', function () { if (i === 3) handoff(state.session, b); else ask(c); });
      chips.appendChild(b);
    });
    if (onlyGreeting) msgs.appendChild(chips); // chips sit in the thread, right under the welcome
    Array.prototype.forEach.call(msgs.querySelectorAll('.mym-ai-cards'), function (r, i) { r.scrollLeft = rowScroll[i] || 0; });
    msgs.scrollTop = atBottom ? msgs.scrollHeight : oldTop;
    sendBtn.disabled = state.busy; cam.disabled = state.busy;
    foot.classList.toggle('is-wa-inline', state.thread.slice(-3).some(function (m) { return m.handoff; })); // one WhatsApp entry at a time
    panel.setAttribute('aria-busy', String(state.busy));
  }

  function bubble(m) {
    var w = el('div', 'mym-ai-msg mym-ai-msg--' + m.who);
    var txt = textOf(m);
    // Each message keeps the direction and type of its own language (earlier EN messages stay LTR after a switch to AR).
    var ml = m.lang || (m.kind || !txt ? lang : isAr(txt) ? 'ar' : 'en');
    w.lang = ml; w.dir = ml === 'ar' ? 'rtl' : 'ltr';
    if (m.image) { var im = el('img', 'mym-ai-msg__photo'); im.src = m.image; im.alt = t.yourPhoto; w.appendChild(im); }
    else if (m.photo) { var ph = el('p', 'mym-ai-msg__photo-note'); ph.appendChild(svg(ICON.camera, 16)); ph.appendChild(el('span', null, T[ml].photoShared)); w.appendChild(ph); }
    if (txt) w.appendChild(para(txt));
    if (m.failed) {
      var fr = el('div', 'mym-ai-failed'); fr.appendChild(el('span', null, t.notSent + ' ·'));
      var rb = el('button', 'mym-ai-retry', t.retry); rb.type = 'button';
      rb.addEventListener('click', function () { if (state.busy) return; var i = state.thread.indexOf(m); if (i > -1) state.thread.splice(i, 2); ask(m.text); });
      fr.appendChild(rb); w.appendChild(fr);
    }
    if (m.products && m.products.length && !m.unverified) {
      w.appendChild(cards(m.products));
      var va = viewAllHref(m);
      if (va) { var vl = el('a', 'mym-ai-viewall', T[ml].viewAll); vl.href = va; vl.addEventListener('click', function () { rm(SS, 'mym_ai_open'); }); w.appendChild(vl); } // the page opens with the chat closed; "Back to the chat" reopens it
    }
    if (m.kind === 'picked' && m === state.thread[state.thread.length - 1]) {
      var row = el('div', 'mym-ai-chips mym-ai-chips--inline');
      var cb = el('button', 'mym-ai-chip', t.crossQ); cb.type = 'button';
      cb.addEventListener('click', function () { ask(t.crossQ); });
      row.appendChild(cb); w.appendChild(row);
    }
    if (m.handoff) {
      var b = el('button', 'mym-ai-wa'); b.type = 'button'; b.appendChild(svg(ICON.wa, 16)); b.appendChild(el('span', null, T[ml].wa));
      b.addEventListener('click', function () { handoff(m.session, b); });
      w.appendChild(b);
    }
    return w;
  }

  // One paragraph per message; each line is its own block (delivery/returns), product names (FSI…PDI) stay on one line.
  function para(txt) {
    var p = el('p');
    String(txt).split('\n').forEach(function (line) {
      if (!line.trim()) return;
      var ln = el('span', 'mym-ai-line');
      line.split(/(\u2068[^\u2069]*\u2069)/).forEach(function (part) {
        if (!part) return;
        if (part.charAt(0) === '\u2068') { var n = el('bdi', 'mym-ai-name', part.slice(1, -1)); ln.appendChild(n); }
        else part.split(/(https:\/\/[^\s<>"'«»]*[^\s<>"'«».,:;!?)،])/).forEach(function (bit, i) { // https links (tracking, account) open in a new tab
          if (!bit) return;
          if (i % 2) { var a = el('a', 'mym-ai-link', bit); a.href = bit; a.target = '_blank'; a.rel = 'noopener noreferrer'; a.dir = 'ltr'; a.style.textDecoration = 'underline'; a.style.overflowWrap = 'anywhere'; ln.appendChild(a); }
          else ln.appendChild(document.createTextNode(bit));
        });
      });
      p.appendChild(ln);
    });
    return p;
  }

  function money(p) {
    var n = Number(p.price); if (p.price == null || !isFinite(n)) return '';
    var s = n.toLocaleString('en-US', { maximumFractionDigits: n % 1 ? 2 : 0 });
    var cur = p.currency && p.currency !== 'SAR' ? p.currency : t.from; // the store writes SR / ر.س
    return lang === 'ar' ? s + '\u00a0' + cur : cur + '\u00a0' + s; // number and currency never split
  }

  // Price and stock as the storefront shows them right now (incl. VAT, current market currency); sold-out pieces are dropped.
  function live(list) {
    return Promise.resolve((list || []).filter(function (p) { return p.available !== false && p.handle; }));
  }

  // Kept cards: re-check price and stock once per page for the latest two suggestion rows.
  var refreshed = false;
  function refreshCards() {
    if (refreshed) return; refreshed = true;
    var rows = state.thread.filter(function (m) { return m.products && m.products.length; });
    var ep = state.epoch;
    var ids = []; rows.forEach(function (m) { m.products.forEach(function (p) { var id = pidOf(p); if (id && ids.indexOf(id) < 0) ids.push(id); }); });
    if (!ids.length) return;
    var batches = []; for (var k = 0; k < ids.length; k += 24) batches.push(ids.slice(k, k + 24));
    Promise.all(batches.map(function (batch) { return api('/v1/products', { ids: batch, locale: lang }); })).then(function (responses) {
      var j = { products: [] }; responses.forEach(function (r) { j.products = j.products.concat(r.products || []); });
      if (ep !== state.epoch) return;
      var byId = {}; (j.products || []).forEach(function (p) { byId[pidOf(p)] = p; });
      rows.forEach(function (m) { m.products = m.products.map(function (p) { return byId[pidOf(p)]; }).filter(Boolean); delete m.unverified; });
      save(); if (!state.busy) render();
    }).catch(function () {});
  }

  var pidOf = function (p) { return Number(p.id) || Number(String(p.product_id || '').split('/').pop()) || null; };
  function localUrl(p) {
    var u = /^https:\/\/(www\.)?miraymano\.com\//.test(p.url || '') ? p.url.replace(/^https:\/\/(www\.)?miraymano\.com/, '') : '/products/' + encodeURIComponent(p.handle || '');
    u = u.replace(/^\/ar(?=\/)/, ''); // follow the language the visitor is browsing in now
    return (lang === 'ar' ? '/ar' : '') + u;
  }

  // "View all": the storefront page with every piece the chat proposed in this set, same order (backend view_all; for older
  // messages, built from the cards). Two pieces or more; never a count.
  function viewAllHref(m) {
    var path = m.viewAll;
    if (!path) { // product ids only, never handles (handles can carry designer names)
      var ids = (m.products || []).map(pidOf).filter(Boolean).slice(0, 20);
      if (ids.length < 2) return null;
      path = '/search?view=mym-picks&type=product&q=' + encodeURIComponent('picks:' + ids.join(','));
    }
    if (!/^\/search\?view=mym-picks&/.test(path) || (m.products || []).length < 2) return null;
    return (lang === 'ar' ? '/ar' : '') + path;
  }

  function cards(list) {
    // Up to four pieces: a two-column grid, every card whole. More: a snap row with a faded edge.
    var row = el('div', 'mym-ai-cards' + (list.length <= 4 ? ' mym-ai-cards--grid' : ''));
    list.forEach(function (p, n) {
      var a = el('a', 'mym-ai-card'); a.href = localUrl(p);
      a.addEventListener('click', function () { picked(p); });
      var f = el('span', 'mym-ai-card__img');
      if (p.image_url) {
        // Eager: lazy images inside a horizontal (RTL) scroller were never requested.
        var i = el('img'); i.loading = n < 4 ? 'eager' : 'lazy'; i.decoding = 'async'; i.alt = cleanTitle(p.title); i.width = 160; i.height = 200;
        i.onerror = function () { a.remove(); };
        i.onload = function () { f.classList.add('is-loaded'); }; // fades in over the placeholder
        i.src = p.image_url + (p.image_url.indexOf('?') > -1 ? '&' : '?') + 'width=320'; f.appendChild(i);
        if (i.complete && i.naturalWidth) f.classList.add('is-loaded');
      }
      a.appendChild(f);
      // No vendor/designer names in the storefront UI: the card shows the photo, title and price only.
      var ti = el('span', 'mym-ai-card__title', cleanTitle(p.title)); ti.dir = 'auto'; a.appendChild(ti);
        var pr = el('span', 'mym-ai-card__price', money(p)); pr.dir = lang === 'ar' ? 'rtl' : 'ltr';
      if (p.compare_at_price) { var s = el('s', null, money({ price: p.compare_at_price, currency: p.currency })); pr.appendChild(document.createTextNode(' ')); pr.appendChild(s); }
      a.appendChild(pr);
      row.appendChild(a);
    });
    return row;
  }

  // The customer opens a suggested piece: remember it, keep the chat open on the product page.
  function picked(p) {
    var id = pidOf(p);
    if (id) track('c', { id: id });
    state.anchor = { id: id, handle: p.handle, title: p.title, at: Date.now() }; save();
    wr(SS, 'mym_ai_picked', { id: id, handle: p.handle, title: p.title, at: Date.now() });
    if (!embedded) wr(SS, 'mym_ai_open', 1);
  }

  function api(path, body) {
    var ctl = new AbortController(), timer = setTimeout(function () { ctl.abort(); }, 55000);
    return fetch(API + path, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body), credentials: 'omit', signal: ctl.signal })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) { var e = new Error('api'); e.code = j && j.error && j.error.code; throw e; } return j; }); }).finally(function () { clearTimeout(timer); });
  }

  function anchorNow() {
    if (here && here.id) return here;
    if (state.anchor && (state.anchor.id || state.anchor.handle) && Date.now() - (state.anchor.at || 0) < 2 * 36e5) return state.anchor; // a pick from hours ago is not "it" any more
    for (var i = state.thread.length - 1; i >= 0; i--) { var m = state.thread[i]; if (m.products && m.products.length) { var p = m.products[0]; return { id: pidOf(p), handle: p.handle, title: p.title }; } }
    return null;
  }

  function ask(text) {
    if (state.busy) return;
    if (panel.classList.contains('is-sheet')) setSheet(false);
    var mine = { who: 'me', text: text }; push(mine);
    track('q', { w: text });
    var history = state.thread.filter(function (m) { return m.text && !m.greeting && !m.local && !m.kind; }).slice(-30).map(function (m) { return { role: m.who === 'me' ? 'user' : 'assistant', content: m.text.slice(0, 2000) }; });
    var body = { messages: history, locale: lang, mode: 'auto', events: events(), client_forget: true };
    if (LS) body.visitor_id = getVid();
    var an = anchorNow(); if (an) body.anchor = { id: an.id || undefined, handle: an.handle || undefined };
    var shown = []; state.thread.slice(-8).forEach(function (m) { (m.products || []).forEach(function (p) { var id = pidOf(p); if (id) shown.push(id); }); });
    if (shown.length) body.exclude = shown.slice(-40);
    if (state.session) body.session_id = state.session;
    if (ctx) body.context = ctx;
    if (customer) body.customer = customer;
    busy(true);
    var ep = state.epoch; // "New chat" / "Forget me" while waiting: the late reply is dropped
    api('/v1/chat', body).then(function (j) {
      if (ep !== state.epoch) return;
      if (j.forget) { clearDevice(); state.thread.push({ who: 'bot', text: j.reply, local: true, ts: Date.now() }); return; } // "forget me" typed in the chat
      state.session = j.session_id;
      return live(j.products).then(function (ps) { if (ep === state.epoch) state.thread.push({ who: 'bot', text: j.reply, products: ps, viewAll: j.view_all || null, handoff: j.handoff_suggested, session: j.session_id, ts: Date.now() }); });
    }).catch(function (e) {
      if (ep !== state.epoch) return;
      var off = !(e && e.code) && (navigator.onLine === false || e && e.name === 'TypeError');
      if (off) mine.failed = true;
      state.thread.push({ who: 'bot', kind: 'err', code: off ? 'offline' : e && e.code, lang: lang, local: true, handoff: !off, session: state.session, ts: Date.now() });
    }).then(function () { if (ep !== state.epoch) return; busy(false); save(); render(); });
  }

  var slowTimer = null;
  function busy(on) {
    state.busy = on; state.busySince = Date.now(); clearTimeout(slowTimer);
    if (on) slowTimer = setTimeout(function () { if (state.busy) render(); }, 8100);
    render();
  }

  function shrink(f) {
    return new Promise(function (res, rej) {
      if (f.size > 15 * 1024 * 1024) { var e = new Error('big'); e.code = 'image_too_large'; return rej(e); }
      if (!/^image\/(jpeg|png|webp|gif|heic|heif)$/.test(f.type)) { var e = new Error('img'); e.code = 'unsupported_media'; return rej(e); }
      var url = URL.createObjectURL(f), img = new Image();
      img.onload = function () {
        var k = Math.min(1, 1024 / Math.max(img.naturalWidth, img.naturalHeight)), c = document.createElement('canvas');
        c.width = Math.round(img.naturalWidth * k); c.height = Math.round(img.naturalHeight * k);
        c.getContext('2d').drawImage(img, 0, 0, c.width, c.height); URL.revokeObjectURL(url);
        res(c.toDataURL('image/jpeg', 0.86));
      };
      img.onerror = function () { URL.revokeObjectURL(url); var e = new Error('img'); e.code = 'unsupported_media'; rej(e); };
      img.src = url;
    });
  }

  function photoSearch(data, caption) {
    if (!state.open) toggle(true);
    if (state.busy) return;
    var ep = state.epoch;
    state.thread.push({ who: 'me', image: data, text: caption || '', local: true, ts: Date.now() });
    save(); busy(true);
    api('/v1/visual-search', { image: data, locale: lang, limit: 8 }).then(function (j) {
      if (ep !== state.epoch) return;
      var top = j.results[0]; // same rule as /search: the backend's exact piece, still published and in stock, shown first
      state.thread.push({ who: 'bot', kind: 'photo', local: true, n: j.results.length, low: !!j.low_confidence, exact: j.exact_match === true && !!top && top.available !== false, products: j.results, viewAll: j.view_all || null, ts: Date.now() });
    }).catch(function (e) { if (ep === state.epoch) state.thread.push({ who: 'bot', kind: 'err', code: !(e && e.code) && navigator.onLine === false ? 'offline' : e && e.code, lang: lang, local: true, ts: Date.now() }); })
      .then(function () { if (ep !== state.epoch) return; busy(false); save(); });
  }

  function handoff(session, btn) {
    // Open the window synchronously (popup blockers), then point it at the prefilled WhatsApp chat.
    var win = window.open('about:blank', '_blank');
    var body = { channel: 'whatsapp', locale: lang };
    if (session) body.session_id = session;
    var label = btn && btn.querySelector('span:not(.mym-ai__ico)'), was = label && label.textContent;
    if (btn) { btn.disabled = true; btn.classList.add('is-opening'); if (label && !btn.classList.contains('mym-ai-chip')) label.textContent = t.opening; else if (btn.classList.contains('mym-ai-chip')) { was = btn.textContent; btn.textContent = t.opening; } }
    api('/v1/handoff', body).then(function (j) { return j.whatsapp_url; })
      .catch(function () { return 'https://wa.me/' + WA; })
      .then(function (u) {
        if (!/^https:\/\/wa\.me\//.test(u)) u = 'https://wa.me/' + WA;
        if (win) { try { win.opener = null; } catch (e) {} win.location.href = u; } else window.location.href = u;
        if (btn) setTimeout(function () { btn.disabled = false; btn.classList.remove('is-opening'); if (btn.classList.contains('mym-ai-chip')) btn.textContent = was; else if (label) label.textContent = was; }, 1500);
      });
  }

  /* entry points: header "Search by photo" button and any [data-mym-ai-open] link */
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('[data-mym-ai-photo]');
    if (p) { e.preventDefault(); toggle(true); file.click(); return; }
    var o = e.target.closest && e.target.closest('[data-mym-ai-open]');
    if (o) { e.preventDefault(); toggle(true); }
  });

  // Another tab changed the conversation: show the same thread here.
  window.addEventListener('storage', function (e) {
    if ((e.key !== tkey() && e.key !== 'mym_ai_vid') || state.busy) return;
    var d = loadThread(); state.thread = d.thread; state.session = d.session; state.anchor = d.anchor;
    if (!state.thread.length && state.open) greet(); else render();
  });

  /* ---------- start ---------- */
  var pick = rd(SS, 'mym_ai_picked');
  if (pick) rm(SS, 'mym_ai_picked');
  var landed = pick && here && Date.now() - (pick.at || 0) < 10 * 6e4 && (pick.id === here.id || (pick.handle && pick.handle === here.handle));
  if (landed) {
    state.anchor = { id: here.id, handle: here.handle, title: here.title || pick.title, at: Date.now() };
    if (!state.thread.length) greet();
    push({ who: 'bot', kind: 'picked', local: true, title: here.title || pick.title });
  }
  render();
  if (embedded) { if (!state.thread.length) greet(); }
  else if (/[?&]mym_ai=(1|open|support)/.test(location.search)) toggle(true);
  else if (landed || rd(SS, 'mym_ai_open')) {
    if (phone() && launcher) { launcher.classList.add('has-new'); rm(SS, 'mym_ai_open'); } // phones: the full-screen chat waits behind the launcher
    else toggle(true, { restore: true });
  }
})();
